<div (click)="close()" role="alert">
  <div class="text-center" *ngFor="let message of messages; let i = index">
    {{message?.errorMessage}}
  </div>
</div>